export default "__VITE_ASSET__DQzpnUDb__"